import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';

//styles
import {
  Input,
  ChoiceBox,
  PickerWrapper,
  ChoiceBoxLabel,
  PickerError,
  PickerErrorEmpty,
} from './index.styled';
import { Asterisk } from '../Label/index.styled';
import { Flex } from 'components/styled/Flex';
//helper
import { days } from 'helper/arrivalDepartureDays';

const WeekPicker = ({ name, label, setFieldValue, values, error }) => {
  const { t } = useTranslation();
  const selectAll = value => {
    days.forEach(day => setFieldValue(`${name}.${day}`, !value));
  };

  return (
    <Flex flexDirection="column" margin="0 0 1rem">
      <ChoiceBoxLabel error={error}>
        {t(label)} <Asterisk>*</Asterisk>
      </ChoiceBoxLabel>
      <Flex flexWrap="wrap" gap="0.5rem">
        {map(days, day => (
          <PickerWrapper name={name} key={day}>
            <Input
              onClick={() => setFieldValue(`${name}_all`, false)}
              type="checkbox"
              name={`${name}.${day}`}
            />
            <ChoiceBox>{t(day)}</ChoiceBox>
          </PickerWrapper>
        ))}

        <PickerWrapper>
          <Input
            type="checkbox"
            onClick={() => selectAll(values[`${name}_all`])}
            name={`${name}_all`}
          />
          <ChoiceBox>{t('All')}</ChoiceBox>
        </PickerWrapper>
      </Flex>
      {error ? <PickerError>{t(error)}</PickerError> : <PickerErrorEmpty />}
    </Flex>
  );
};

export default WeekPicker;

WeekPicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  error: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
};
